/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Misc_Gameawards_Nogamesbody3Inputs */

const id_misc_gameawards_nogamesbody3 = /** @type {(inputs: Misc_Gameawards_Nogamesbody3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kembali lagi setelah The Game Awards!`)
};

const ms_misc_gameawards_nogamesbody3 = /** @type {(inputs: Misc_Gameawards_Nogamesbody3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Datang semula selepas The Game Awards!`)
};

const da_misc_gameawards_nogamesbody3 = /** @type {(inputs: Misc_Gameawards_Nogamesbody3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kig tilbage efter The Game Awards!`)
};

const de_misc_gameawards_nogamesbody3 = /** @type {(inputs: Misc_Gameawards_Nogamesbody3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schauen Sie nach The Game Awards wieder vorbei!`)
};

const en_us2_misc_gameawards_nogamesbody3 = /** @type {(inputs: Misc_Gameawards_Nogamesbody3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Check back after The Game Awards!`)
};

const es_es2_misc_gameawards_nogamesbody3 = /** @type {(inputs: Misc_Gameawards_Nogamesbody3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vuelve después de The Game Awards!`)
};

const es_mx2_misc_gameawards_nogamesbody3 = /** @type {(inputs: Misc_Gameawards_Nogamesbody3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¡Regresa después de The Game Awards!`)
};

const fil_misc_gameawards_nogamesbody3 = /** @type {(inputs: Misc_Gameawards_Nogamesbody3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bumalik pagkatapos ng The Game Awards!`)
};

const fr_misc_gameawards_nogamesbody3 = /** @type {(inputs: Misc_Gameawards_Nogamesbody3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Revenez après les Game Awards !`)
};

const it_misc_gameawards_nogamesbody3 = /** @type {(inputs: Misc_Gameawards_Nogamesbody3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Torna dopo i The Game Awards!`)
};

const hu_misc_gameawards_nogamesbody3 = /** @type {(inputs: Misc_Gameawards_Nogamesbody3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nézz vissza a The Game Awards után!`)
};

const nl_misc_gameawards_nogamesbody3 = /** @type {(inputs: Misc_Gameawards_Nogamesbody3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kom terug na The Game Awards!`)
};

const no_misc_gameawards_nogamesbody3 = /** @type {(inputs: Misc_Gameawards_Nogamesbody3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kom tilbake etter The Game Awards!`)
};

const pl_misc_gameawards_nogamesbody3 = /** @type {(inputs: Misc_Gameawards_Nogamesbody3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wróć po The Game Awards!`)
};

const pt_br2_misc_gameawards_nogamesbody3 = /** @type {(inputs: Misc_Gameawards_Nogamesbody3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Volte depois de The Game Awards!`)
};

const pt_misc_gameawards_nogamesbody3 = /** @type {(inputs: Misc_Gameawards_Nogamesbody3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Volte depois dos The Game Awards!`)
};

const ro_misc_gameawards_nogamesbody3 = /** @type {(inputs: Misc_Gameawards_Nogamesbody3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Revino după The Game Awards!`)
};

const fi_misc_gameawards_nogamesbody3 = /** @type {(inputs: Misc_Gameawards_Nogamesbody3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Palaa The Game Awardsin jälkeen!`)
};

const sv_misc_gameawards_nogamesbody3 = /** @type {(inputs: Misc_Gameawards_Nogamesbody3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kom tillbaka efter The Game Awards!`)
};

const vi_misc_gameawards_nogamesbody3 = /** @type {(inputs: Misc_Gameawards_Nogamesbody3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quay lại sau The Game Awards!`)
};

const tr_misc_gameawards_nogamesbody3 = /** @type {(inputs: Misc_Gameawards_Nogamesbody3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The Game Awards'tan sonra tekrar gelin!`)
};

const cs_misc_gameawards_nogamesbody3 = /** @type {(inputs: Misc_Gameawards_Nogamesbody3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vraťte se po The Game Awards!`)
};

const bg_misc_gameawards_nogamesbody3 = /** @type {(inputs: Misc_Gameawards_Nogamesbody3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Върнете се след The Game Awards!`)
};

const ru_misc_gameawards_nogamesbody3 = /** @type {(inputs: Misc_Gameawards_Nogamesbody3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Загляните после The Game Awards!`)
};

const uk_misc_gameawards_nogamesbody3 = /** @type {(inputs: Misc_Gameawards_Nogamesbody3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Повертайтеся після The Game Awards!`)
};

const ar_misc_gameawards_nogamesbody3 = /** @type {(inputs: Misc_Gameawards_Nogamesbody3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`عد بعد The Game Awards!`)
};

const hi_misc_gameawards_nogamesbody3 = /** @type {(inputs: Misc_Gameawards_Nogamesbody3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`द गेम अवार्ड्स के बाद वापस आएँ!`)
};

const th_misc_gameawards_nogamesbody3 = /** @type {(inputs: Misc_Gameawards_Nogamesbody3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`กลับมาตรวจสอบหลัง The Game Awards!`)
};

const ja_misc_gameawards_nogamesbody3 = /** @type {(inputs: Misc_Gameawards_Nogamesbody3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The Game Awards 後にまたチェックしてください！`)
};

const zh_cn2_misc_gameawards_nogamesbody3 = /** @type {(inputs: Misc_Gameawards_Nogamesbody3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`请在 The Game Awards 结束后回来查看！`)
};

const zh_hant1_misc_gameawards_nogamesbody3 = /** @type {(inputs: Misc_Gameawards_Nogamesbody3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`請在 The Game Awards 結束後回來檢視！`)
};

const ko_misc_gameawards_nogamesbody3 = /** @type {(inputs: Misc_Gameawards_Nogamesbody3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The Game Awards 이후에 다시 확인하세요!`)
};

/**
* | output |
* | --- |
* | "Check back after The Game Awards!" |
*
* @param {Misc_Gameawards_Nogamesbody3Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const misc_gameawards_nogamesbody3 = /** @type {((inputs?: Misc_Gameawards_Nogamesbody3Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Misc_Gameawards_Nogamesbody3Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_misc_gameawards_nogamesbody3(inputs)
	if (locale === "ms") return ms_misc_gameawards_nogamesbody3(inputs)
	if (locale === "da") return da_misc_gameawards_nogamesbody3(inputs)
	if (locale === "de") return de_misc_gameawards_nogamesbody3(inputs)
	if (locale === "en-US") return en_us2_misc_gameawards_nogamesbody3(inputs)
	if (locale === "es-ES") return es_es2_misc_gameawards_nogamesbody3(inputs)
	if (locale === "es-MX") return es_mx2_misc_gameawards_nogamesbody3(inputs)
	if (locale === "fil") return fil_misc_gameawards_nogamesbody3(inputs)
	if (locale === "fr") return fr_misc_gameawards_nogamesbody3(inputs)
	if (locale === "it") return it_misc_gameawards_nogamesbody3(inputs)
	if (locale === "hu") return hu_misc_gameawards_nogamesbody3(inputs)
	if (locale === "nl") return nl_misc_gameawards_nogamesbody3(inputs)
	if (locale === "no") return no_misc_gameawards_nogamesbody3(inputs)
	if (locale === "pl") return pl_misc_gameawards_nogamesbody3(inputs)
	if (locale === "pt-BR") return pt_br2_misc_gameawards_nogamesbody3(inputs)
	if (locale === "pt") return pt_misc_gameawards_nogamesbody3(inputs)
	if (locale === "ro") return ro_misc_gameawards_nogamesbody3(inputs)
	if (locale === "fi") return fi_misc_gameawards_nogamesbody3(inputs)
	if (locale === "sv") return sv_misc_gameawards_nogamesbody3(inputs)
	if (locale === "vi") return vi_misc_gameawards_nogamesbody3(inputs)
	if (locale === "tr") return tr_misc_gameawards_nogamesbody3(inputs)
	if (locale === "cs") return cs_misc_gameawards_nogamesbody3(inputs)
	if (locale === "bg") return bg_misc_gameawards_nogamesbody3(inputs)
	if (locale === "ru") return ru_misc_gameawards_nogamesbody3(inputs)
	if (locale === "uk") return uk_misc_gameawards_nogamesbody3(inputs)
	if (locale === "ar") return ar_misc_gameawards_nogamesbody3(inputs)
	if (locale === "hi") return hi_misc_gameawards_nogamesbody3(inputs)
	if (locale === "th") return th_misc_gameawards_nogamesbody3(inputs)
	if (locale === "ja") return ja_misc_gameawards_nogamesbody3(inputs)
	if (locale === "zh-CN") return zh_cn2_misc_gameawards_nogamesbody3(inputs)
	if (locale === "zh-Hant") return zh_hant1_misc_gameawards_nogamesbody3(inputs)
	return ko_misc_gameawards_nogamesbody3(inputs)
});
export { misc_gameawards_nogamesbody3 as "misc.gameAwards.noGamesBody" }